// webapp/src/stores/checklistResponse.js
import { observable, configure, action } from 'mobx';
import LocalModel from './localModel';
import util from 'preact-util';

configure({ enforceActions: 'always' });

class ChecklistResponseStore extends LocalModel {
    constructor() {
        super('checklistResponse', {
            namePlural: 'checklistResponses',
            namePluralReal: 'checklistresponses', // admin list path is /api/checklists/:id/responses; see loadForChecklist
            sort: '-createdDate',
            limit: 500,
            api: {
                search: { url: '/api/checklists/', params: {} },
                load: { url: '/api/checklists/', params: {} },
                save: { url: '/api/checklists/', params: {} },
                delete: { url: '/api/checklists/', params: {} },
            },
        });
    }

    @observable checklistResponse = {};

    @observable checklistResponses = [];

    @action
    async loadForChecklist(checklistId, params = {}) {
        const response = await util.fetchApi('/api/checklists/' + checklistId + '/responses', { method: 'GET' }, params);
        const list = Array.isArray(response?.data) ? response.data : [];
        this.updateKeyValue('checklistResponses', list);
        return list;
    }
}

const checklistResponseStore = new ChecklistResponseStore();
export default checklistResponseStore;
